module.exports = __webpack_public_path__ + "img/drop.5059b2a1.svg";